// Safe defaults; can be overridden per-environment by replacing this file or wiring env vars
// into your build tooling. Keeping these simple ensures the dashboard remains interactive
// even when custom configuration is unavailable.
export const ENABLE_DASHBOARD_NOTIFICATIONS = true;
export const ENABLE_PERSISTED_DISMISS = false;
const isStrictTrue = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase() === 'true';
const isStrictFalse = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase() === 'false';
const runtimeConfig = () =>
  typeof window !== 'undefined' ? window.__AFFINITYAI_CONFIG__ || {} : {};
const runtimeContextAssistFlag =
  typeof window !== 'undefined' ? runtimeConfig()?.CONTEXT_ASSIST_ENABLED : undefined;
export const ENABLE_CONTEXT_ASSIST =
  isStrictTrue(process.env.REACT_APP_CONTEXT_ASSIST_ENABLED) ||
  isStrictTrue(process.env.NEXT_PUBLIC_CONTEXT_ASSIST_ENABLED) ||
  runtimeContextAssistFlag === true ||
  isStrictTrue(runtimeContextAssistFlag);

export function isGoogleSlidesExportEnabled(env = process.env, runtime = runtimeConfig()) {
  const values = [
    env.ENABLE_GOOGLE_SLIDES_EXPORT,
    env.REACT_APP_ENABLE_GOOGLE_SLIDES_EXPORT,
    env.NEXT_PUBLIC_ENABLE_GOOGLE_SLIDES_EXPORT,
    runtime?.ENABLE_GOOGLE_SLIDES_EXPORT,
    runtime?.GOOGLE_SLIDES_EXPORT_ENABLED,
  ];
  if (values.some(isStrictFalse)) return false;
  return values.some(isStrictTrue);
}

export const ENABLE_GOOGLE_SLIDES_EXPORT = isGoogleSlidesExportEnabled();

export function isStartFlowEnabled(env = process.env, runtime = runtimeConfig()) {
  const values = [
    env.ENABLE_START_FLOW,
    env.REACT_APP_ENABLE_START_FLOW,
    env.NEXT_PUBLIC_ENABLE_START_FLOW,
    runtime?.ENABLE_START_FLOW,
    runtime?.START_FLOW_ENABLED,
  ];
  if (values.some(isStrictFalse)) return false;
  return values.some(isStrictTrue);
}

export const ENABLE_START_FLOW = isStartFlowEnabled();

export default {
  ENABLE_DASHBOARD_NOTIFICATIONS,
  ENABLE_PERSISTED_DISMISS,
  ENABLE_CONTEXT_ASSIST,
  ENABLE_GOOGLE_SLIDES_EXPORT,
  ENABLE_START_FLOW,
};
